import { CONTESTS_SHOW_ERROR, CONTESTS_SHOW_SUCCESS } from '../actions/contests';

const defaultState = null;

export default (state = defaultState, { type, payload = {} }) => {
  switch (type) {
    case CONTESTS_SHOW_ERROR: {
      return 'Connection lost - the results you see may not be up to date.';
    }

    case CONTESTS_SHOW_SUCCESS: {
      return null;
    }

    default: {
      return state;
    }
  }
};
